// extracted by mini-css-extract-plugin
export var conversationListItem = "_x8-2";
export var fullBleedList = "_x8-3";
export var messageText = "_x8-1";
export var previewText = "_x8-0";